import axios from 'axios';
import defaultConfig from '../config';
import logException from '../logs';
import session from './session';

import _ from "lodash";

let def = {
	'x-api-key': defaultConfig.api.auth.key,
	'x-api-secret': defaultConfig.api.auth.secret,
};

const obj = {
	true : () => {
		return {
			...def,
			authorization: 'Bearer ' + session.get('token'),
		}
	},
	false: () => {
		return def;
	},
};

let apiConfig = {};

axios.interceptors.response.use(undefined, function (error,a,b,c) {
	logException(error, { data: 'api'}); // send to sentry
	return Promise.reject(error); // throw error
});

axios.defaults.paramsSerializer = function (params) {
	return Object.keys(params)
		.map(key => {
			const val = params[key];
			if (Array.isArray(val)) {
				return val.map(v => `${key}=${encodeURIComponent(v)}`).join('&');
			}
			if (val === undefined || val === null) return '';
			return `${key}=${encodeURIComponent(val)}`;
		})
		.filter(part => part.length > 0)
		.join('&');
};

export default {
	get(api, options) {
		let config = {
			headers: obj[session.get('token') !== null]()
		};

		if (options) {
			config = _.merge(config, options);
		}

		return axios
			.get(`${defaultConfig.api.host}${api}`, config)
			.then(response => {
				return response.data;
			})
			.catch(error => {
				if (error.response) {
					const errorData = error.response.data;
					// Unauthorized
					if (errorData.statusCode === 401) {
						// logout, redirect to login
					}

					throw errorData;
				}
				return error;
			});
	},

	put(api, body) {
		const config = {
			headers: obj[session.get('token') !== null]()
		};
		return axios
			.put(`${defaultConfig.api.host}${api}`, body, config)
			.then(response => {
				return response.data;
			})
			.catch(error => {
				if (error.response) {
					const errorData = error.response.data;
					// Unauthorized
					if (errorData.statusCode === 401) {
						// logout, redirect to login
					}

					throw errorData;
				}
				throw error;
			});
	},

	post(api, body, option) {
		let config = {
			headers: obj[session.get('token') !== null]()
		};

		if (option) {
			config = _.merge(config, option);
		}

		return axios
			.post(`${defaultConfig.api.host}${api}`, body, config)
			.then(response => {
				return response.data;
			})
			.catch(error => {
				if (error.response) {
					const errorData = error.response.data;
					// Unauthorized
					if (errorData.statusCode === 401) {
						// logout, redirect to login
					}

					throw errorData;
				}
				throw error;
			});
	},

	delete(api, body) {
		const config = {
			headers: obj[session.get('token') !== null]()
		};

		if (body) {
			config.data = body;
		}
		
		return axios
			.delete(`${defaultConfig.api.host}${api}`, config)
			.then(response => {
				return response.data;
			})
			.catch(error => {
				if (error.response) {
					const errorData = error.response.data;
					// Unauthorized
					if (errorData.statusCode === 401) {
						// logout, redirect to login
					}

					throw errorData;
				}
				throw error;
			});
	}
};
